import { ref } from "vue";
import type { Ref } from "vue";

export const useGlobalStore = defineStore("counter", () => {
  const colorMode = useColorMode();
  const isDarkMode: Ref<boolean> = ref(
    colorMode.preference === "dark" ? true : false
  );

  return {
    isDarkMode,
  };
});
